<template>
  <div class="d-flex align-items-center justify-content-center h-100">
    <b-card class="paper text-center p-4" no-body>
      <div v-if="atendimento && atendimento.orcamentos.length > 0">
        <b-icon icon="check-circle" font-scale="8" variant="success m-auto mt-5 mb-4"/>
        <h2 class="mt-3 mb-3">
          {{ $t('auto_atendimento.show.orcamento_sucesso') }}
        </h2>
      </div>
      <div v-else>
        <b-icon-clock font-scale="8" variant="info m-auto mt-5 mb-4 p-3"/>
        <h2 class="mt-3 mb-3">{{ $t('auto_atendimento.show.aguardando') }}</h2>
      </div>

      <div v-if="atendimento && atendimento.orcamentos.length > 0">
        <div
            v-for="(orcamento, idx) in atendimento.orcamentos"
            :key="idx"
            :class="{'d-flex justify-content-between pt-3': true, 'border-bottom': idx+1 !== atendimento.orcamentos.length}"
        >
          <div class="d-flex flex-column">
            <h5 class="mb-1 font-weight-bolder">{{ atendimento.paciente.nome }}</h5>
            <b-button v-if="orcamento.files" variant="link p-0 mr-auto" @click="openPDF(orcamento.files.id)">PDF</b-button>
          </div>
          <div class="d-flex flex-column">
            <h5 class="mb-1 font-weight-bolder ml-auto">R$ {{ orcamento.valor }}</h5>
            <p class="mb-1">{{ orcamento.created_at | formatDate }}</p>
          </div>
        </div>
      </div>

      <b-button
          v-if="atendimento && atendimento.orcamentos.length === 0"
          variant="info mt-5"
          onclick="window.location.reload()"
          block
      >
        {{ $t('auto_atendimento.show.atualizar') }}
      </b-button>

      <b-button v-b-toggle.collapse-1 variant="link">QRCode</b-button>
      <b-collapse id="collapse-1" class="mt-2">
        <qrcode-vue class="qr-code mb-4" :size="500" :value="`${$route.params.id}`"/>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import {VS_URL} from "@/providers/EnvironmentProvider";
import {axiosNative} from "@/providers/AxiosServiceProvider";
import qrcodeVue from "qrcode-vue";

export default {
  name: "Show",
  components: {qrcodeVue},
  data() {
    return {
      atendimento: null
    }
  },
  methods: {
    building () {
      this.$snotify.success(this.$t('auto_atendimento.cadastro.funcionalidade_construcao'))
    },
    openPDF (id) {
      const win = window.open(`${VS_URL}/vaa/baixar/orcamento/${id}`, '_blank')
      win.focus()
    }
  },
  mounted() {
    axiosNative.get(`${VS_URL}/vaa/api/v1/listar/atendimento/${this.$route.params.id}`)
        .then(response => {
          this.atendimento = response.data
        })
        .catch(() => {
          this.$snotify.error(this.$t('auto_atendimento.qr.erro'), {position: 'rightBottom'})
        })
  }
}
</script>

<style lang="scss" scoped>
.paper {
  &:before, &:after {
    content: "";
    height: 8px;
    position: absolute;
    left: 0;
    right: 0;
    -webkit-clip-path: polygon(0% 0%, 5% 100%, 10% 0%, 15% 100%, 20% 0%, 25% 100%, 30% 0%, 35% 100%, 40% 0%, 45% 100%, 50% 0%, 55% 100%, 60% 0%, 65% 100%, 70% 0%, 75% 100%, 80% 0%, 85% 100%, 90% 0%, 95% 100%, 100% 0%);
  }

  &:before {
    //background-color: #d8d8d8;
    background-color: #e2e2e2;
    top: 0;
  }

  &:after {
    background-color: #fff;
    bottom: -8px;
  }
}

.b-icon {
  border: #e2e2e2 10px solid;
  padding: 10px;
  border-radius: 20rem;
}

::v-deep.qr-code {
  img {
    width: 75%;
    border: #f9b112 5px solid;
    border-radius: 10px;
    padding: 1rem;
  }

  canvas {
    width: 75%;
  }
}
</style>
